import React, { useRef } from 'react';
import { ActionCable } from 'react-actioncable-provider'
import { toastr } from "react-redux-toastr";

export default ({ show, message }) => {
  if (!show) return null;

  return (
    <>
      {show &&
        <div className='payment-spinner-box'>
          <div>
            <div id="loader-wrapper"><div id="loader"/></div>
            <h3 className="text-center">{message}</h3>
          </div>
        </div>
      }
    </>
  );
}
